<template>
   <div class="all_form_block active">
      <form>
         <div class="block">
            <div class="name_tools">{{ $store.getters.t('themes') }}</div>
            <div class="all_form">
               <div class="color_block">
                  <div class="radio_color" v-for="(theme, index) in themes" :key="theme.id">
                     <input :id="'background_radio_' + index" name="background_radio" type="radio" :value="theme.id"
                            v-model="theme_id">
                     <label :for="'background_radio_' + index">
                        <img :src="theme.image" :alt="theme.translations[0].name" width="50px">
                     </label>
                  </div>
               </div>
            </div>
         </div>
      </form>
   </div>
</template>

<script>
  export default {
    data() {
      return {
        themes: [],
        theme_id: null,
      };
    },
    mounted() {
    },
    watch: {
      "$parent.themes"(to) {
        this.themes = to;
        
        if (this.$store.state.cv.cvTheme.id !== 0) {
          this.theme_id = this.$store.state.cv.cvTheme.id;
        } else {
          this.theme_id = this.themes[0].id;
        }
        this.updateTheme(this.theme_id);
      },
      theme_id: function (to) {
        this.updateTheme(to);
      }
    },
    methods: {
      updateTheme(id) {
        const theme = this.themes.find(_ => _.id === id);
        if(theme !== undefined){
          let data = {
            id: theme.id,
            class_name: theme.class_name
          };
          this.$store.commit("cvTheme", data);
        }else{
          this.theme_id = this.themes[0].id;
          this.$store.commit("cvTheme", this.themes[0]);
        }
      }
    }
  };
</script>




// WEBPACK FOOTER //
// resources/js/components/pages/cv/color-tab-components/themes.vue